import { useSentryMutation, useSentryQuery } from '@/utils/sentryQueryWrapper';
import { ErrorMessageResponse } from '@/types/error';
import {
  bulkDelayRtoOrders,
  bulkResendOrders,
  delayRtoOrder,
  fetchInventoryOrders,
  resendOrder,
} from '@/api/inventoryService';
import { BulkDelayRtoPayload, BulkResendPayload, InventoryOrdersResponse, ResendPayload, ResendResponse } from '@/types/inventory';

export const useFetchInventoryOrders = (
  page: number,
  perPage: number,
  enabled: boolean = true,
) => {
  return useSentryQuery<InventoryOrdersResponse, ErrorMessageResponse>(
    ['inventory', page, perPage],
    () => fetchInventoryOrders(page, perPage),
    { enabled },
  );
};

export const useResendOrder = () => {
  return useSentryMutation<ResendResponse, ErrorMessageResponse, { uid: string; payload: ResendPayload }>(
    ({ uid, payload }) => resendOrder(uid, payload),
  );
};

export const useDelayRtoOrder = () => {
  return useSentryMutation<unknown, ErrorMessageResponse, { uid: string; reason?: string }>(
    ({ uid, reason }) => delayRtoOrder(uid, reason),
  );
};

export const useBulkResendOrders = () => {
  return useSentryMutation<unknown, ErrorMessageResponse, BulkResendPayload>(
    (payload) => bulkResendOrders(payload),
  );
};

export const useBulkDelayRtoOrders = () => {
  return useSentryMutation<unknown, ErrorMessageResponse, BulkDelayRtoPayload>(
    (payload) => bulkDelayRtoOrders(payload),
  );
};
